import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, Badge, Button, Divider, Field, InputOnChangeData, mergeClasses, Popover, PopoverSurface, PopoverTrigger, SearchBox, SearchBoxChangeEvent, Skeleton, SkeletonItem, Table, TableBody, TableCell, TableCellActions, TableCellLayout, TableHeader, TableHeaderCell, TableRow, Tag } from "@fluentui/react-components";
import { AddIcon, DeleteIcon, EditIcon, FilterIcon, GlobeArrowForwardIcon, GlobeClockIcon, GlobeDesktopIcon, TrashCanIcon, useEditorStyles, useTabStyles } from "../Styles/Editor";
import { ConsultantDropdown } from "../EditorHelpers/ConsultantDropdown";
import { useTranslation } from "react-i18next";
import { Consultant, ConsultantDocument, ConsultantPeppolReceivedCreditNote, ConsultantPeppolReceivedInvoice } from "../../interfaces/Consultant";
import { ApplicationState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ConsultantActionCreators } from "../../store/consultants";
import { useMsal } from "@azure/msal-react";
import * as TeamsState from '../../store/TeamsState';
import { BasicDocumentTypeDropdown, getDocumentTypeString } from '../EditorHelpers/DocumentTypeDropDown';
import { TokenHelper } from "../../TokenHelper";
import { DownloadFileAndSave, DownloadSPOLinkAndNav } from "../Tools/FileDownloadHelper";
import { SharePointSVG } from "../Resources/SharePointSVG";
import { SortHelper } from '../../SortHelper';
import { dataActionCreators, DataState, Invoice } from '../../store/Data';
import { useRigths, useConsultants, useConsultantDocuments, useConsultantPeppolReceivedInvoices, useConsultantPeppolReceivedCreditNotes, useConsultantsInvoices, useCustomers, useInvoices, useProjectsAssigments, useTimeSheetEntries, useSales } from "../Tools/ObjectLoader";
import { ConsultantDocumentAgregator, IsEditable, GetLock, GetAccountingRef, GetAmount, GetDescription, IsPeppol, IsPeppolTest, GetConsultantId, GetDocumentTypeId, GetSource, PeppolStatus } from "./ConsultantDocumentAgregator/ConsultantDocumentAgregator";

interface ConsultantsDocumentsMonth {
    docs: ConsultantDocumentAgregator[];
    year: number;
    month: number;
}

export enum ConsultantsDocumentsPreFilter {
    Buys,
    Sells
}
function GetFilter(d: ConsultantsDocumentsPreFilter | undefined) {
    if (d === undefined) return null;
    switch (d) {
        case ConsultantsDocumentsPreFilter.Buys: {
            return 101;
        }
        case ConsultantsDocumentsPreFilter.Sells: {
            return 1;
        }
    }
    return null;
}

export interface ConsultantsDocumentsTabProp {
    PreFilterConsultantid?: string
    privateDocumentsOnly: boolean;
    preFilter?: ConsultantsDocumentsPreFilter
}

export const ConsultantsDocumentsTab = ({ privateDocumentsOnly, preFilter, PreFilterConsultantid }: ConsultantsDocumentsTabProp) => {
    const data = useSelector<ApplicationState, DataState>((state: ApplicationState) => state.data);
    const { consultants, consultantsLoading } = useConsultants();
    const { consultantDocuments, consultantDocumentsLoading } = useConsultantDocuments();
    const { consultantPeppolReceivedInvoices, consultantPeppolReceivedInvoicesLoading } = useConsultantPeppolReceivedInvoices();
    const { consultantPeppolReceivedCreditNotes, consultantPeppolReceivedCreditNotesLoading } = useConsultantPeppolReceivedCreditNotes();
    const { consultantsInvoices, consultantsInvoicesLoading } = useConsultantsInvoices();
    const { customers, customersLoading } = useCustomers();
    const { invoices, invoicesLoading } = useInvoices();
    const { projectsAssigmentsLoading } = useProjectsAssigments();
    const { timeSheetEntriesLoading } = useTimeSheetEntries();
    const { salesLoading } = useSales();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);

    const isLoading = useMemo(() => {
        return consultantsLoading || consultantDocumentsLoading || consultantPeppolReceivedInvoicesLoading
            || consultantPeppolReceivedCreditNotesLoading || consultantsInvoicesLoading || invoicesLoading
            || customersLoading || projectsAssigmentsLoading || timeSheetEntriesLoading
            || salesLoading;
    }, [consultantsLoading, consultantDocumentsLoading, consultantPeppolReceivedInvoicesLoading,
        consultantPeppolReceivedCreditNotesLoading, consultantsInvoicesLoading, invoicesLoading,
        customersLoading, projectsAssigmentsLoading, timeSheetEntriesLoading,
        salesLoading]);

    const [consultantDocumentsFilter, SetConsultantDocumentsFilter] = useState<ConsultantDocumentAgregator[]>([]);
    const [filterConsultant, setFilterConsultant] = useState<Consultant | undefined>(undefined);
    const [filterDocumentType, setFilterDocumentType] = useState<number | null>(null);
    const ActifFilterDocumentType = useMemo(() => {
        if (preFilter !== undefined) return GetFilter(preFilter);
        return filterDocumentType;
    }, [filterDocumentType, preFilter]);
    const [filter, setFilter] = useState<string | null>(null);
    const { t } = useTranslation();
    const styles = useEditorStyles();
    const stylesTab = useTabStyles();
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState.TeamsState>((state: ApplicationState) => state.teamsState);
    const { isAdmin, canManageConsultantDocuments, consultantid } = useRigths();
    const [consultantDocumentsDoneFilter, SetConsultantDocumentsDoneFilter] = useState<ConsultantsDocumentsMonth[]>([]);

    useEffect(() => {
        //    SetConsultantDocumentsDoneFilter([]);
        //    SetConsultantDocumentsFilter([]);
        setFilterConsultant(undefined);
        setFilterDocumentType(null);
    }, [privateDocumentsOnly, preFilter, PreFilterConsultantid]);

    useEffect(() => {
        if (isLoading) {
            return;
        }
        let consultantDocumentsTemp: ConsultantDocument[] = [];
        if (consultantDocuments !== undefined) {
            // filter consultant documents
            if (privateDocumentsOnly) {
                if (consultantid) {
                    consultantDocumentsTemp = consultantDocuments.filter(cd => cd.consultantid === consultantid);
                }
                else {
                    consultantDocumentsTemp = [];
                }
            }
            else if (filterConsultant !== undefined) {
                consultantDocumentsTemp = consultantDocuments.filter(cd => cd.consultantid === filterConsultant.consultantid);
            }
            else if (PreFilterConsultantid) {
                consultantDocumentsTemp = consultantDocuments.filter(cd => cd.consultantid && cd.consultantid.toUpperCase() === PreFilterConsultantid);
            }
            else {
                consultantDocumentsTemp = [...consultantDocuments];
            }
            if (ActifFilterDocumentType) {
                switch (ActifFilterDocumentType) {
                    case 1: {
                        consultantDocumentsTemp = consultantDocumentsTemp.filter(cd => cd.documentTypeId === 1 || cd.documentTypeId === 2);
                        break;
                    }
                    case 201: {
                        consultantDocumentsTemp = consultantDocumentsTemp.filter(cd => cd.documentTypeId === 201 || cd.documentTypeId === 202);
                        break;
                    }
                    default: {
                        consultantDocumentsTemp = consultantDocumentsTemp.filter(cd => cd.documentTypeId === ActifFilterDocumentType);
                        break;
                    }
                }
            }
            if (filter && filter.length) {
                consultantDocumentsTemp = consultantDocumentsTemp.filter(cd => (cd.documentSource && cd.documentSource.toLowerCase().includes(filter.toLowerCase())) || (cd.description && cd.description.toLowerCase().includes(filter.toLowerCase())));
            }
        }

        // filter Invoices
        let invoicesTemp: Invoice[] = [];
        // Only if all document or buy invoices
        if (invoices && (ActifFilterDocumentType === null || ActifFilterDocumentType === 1 || ActifFilterDocumentType === 2)) {
            if (privateDocumentsOnly) {
                if (consultantid) {
                    invoicesTemp = invoices.filter(cd => cd.consultantid === consultantid);
                }
                else {
                    invoicesTemp = [];
                }
            }
            else if (filterConsultant !== undefined) {
                invoicesTemp = invoices.filter(cd => cd.consultantid === filterConsultant.consultantid);
            }
            else if (PreFilterConsultantid) {
                invoicesTemp = invoices.filter(cd => cd.consultantid.toUpperCase() === PreFilterConsultantid);
            }
            else {
                invoicesTemp = [...invoices];
            }
        }
        if (filter && filter.length) {
            invoicesTemp = invoicesTemp.filter(cd =>
                (cd.description && cd.description.toLowerCase().includes(filter.toLowerCase()))
                || (cd.invoiceRef && cd.invoiceRef.toLowerCase().includes(filter.toLowerCase()))
                || (cd.invoiceDescription && cd.invoiceDescription.toLowerCase().includes(filter.toLowerCase()))
                || (cd.buyerReference && cd.buyerReference.toLowerCase().includes(filter.toLowerCase()))
            );
        }

        // filter consultant Peppol Received Invoices
        let consultantPeppolReceivedInvoicesTemp: ConsultantPeppolReceivedInvoice[] = [];
        // Only if all document or buy invoices
        if (consultantPeppolReceivedInvoices && (ActifFilterDocumentType === null || ActifFilterDocumentType === 11 || ActifFilterDocumentType === 101)) {
            if (privateDocumentsOnly) {
                if (consultantid) {
                    consultantPeppolReceivedInvoicesTemp = consultantPeppolReceivedInvoices.filter(cd => cd.consultantid === consultantid);
                }
                else {
                    consultantPeppolReceivedInvoicesTemp = [];
                }
            }
            else if (filterConsultant !== undefined) {
                consultantPeppolReceivedInvoicesTemp = consultantPeppolReceivedInvoices.filter(cd => cd.consultantid === filterConsultant.consultantid);
            }
            else if (PreFilterConsultantid) {
                consultantPeppolReceivedInvoicesTemp = consultantPeppolReceivedInvoices.filter(cd => cd.consultantid.toUpperCase() === PreFilterConsultantid);
            }
            else {
                consultantPeppolReceivedInvoicesTemp = [...consultantPeppolReceivedInvoices];
            }
        }
        if (filter && filter.length) {
            consultantPeppolReceivedInvoicesTemp = consultantPeppolReceivedInvoicesTemp.filter(cd =>
                (cd.registrationName && cd.registrationName.toLowerCase().includes(filter.toLowerCase()))
                || (cd.description && cd.description.toLowerCase().includes(filter.toLowerCase()))
                || (cd.accountingRef && cd.accountingRef.toLowerCase().includes(filter.toLowerCase()))
                || (cd.id && cd.id.toLowerCase().includes(filter.toLowerCase()))
            );
        }

        // filter consultant Peppol Received Credit Notes
        let consultantPeppolReceivedCreditNotesTemp: ConsultantPeppolReceivedCreditNote[] = [];
        // Only if all document or buy invoices
        if (consultantPeppolReceivedCreditNotes && (ActifFilterDocumentType === null || ActifFilterDocumentType === 11 || ActifFilterDocumentType === 101)) {
            if (privateDocumentsOnly) {
                if (consultantid) {
                    consultantPeppolReceivedCreditNotesTemp = consultantPeppolReceivedCreditNotes.filter(cd => cd.consultantid === consultantid);
                }
                else {
                    consultantPeppolReceivedCreditNotesTemp = [];
                }
            }
            else if (filterConsultant !== undefined) {
                consultantPeppolReceivedCreditNotesTemp = consultantPeppolReceivedCreditNotes.filter(cd => cd.consultantid === filterConsultant.consultantid);
            }
            else if (PreFilterConsultantid) {
                consultantPeppolReceivedCreditNotesTemp = consultantPeppolReceivedCreditNotes.filter(cd => cd.consultantid.toUpperCase() === PreFilterConsultantid);
            }
            else {
                consultantPeppolReceivedCreditNotesTemp = [...consultantPeppolReceivedCreditNotes];
            }
        }
        if (filter && filter.length) {
            consultantPeppolReceivedCreditNotesTemp = consultantPeppolReceivedCreditNotesTemp.filter(cd =>
                (cd.registrationName && cd.registrationName.toLowerCase().includes(filter.toLowerCase()))
                || (cd.description && cd.description.toLowerCase().includes(filter.toLowerCase()))
                || (cd.accountingRef && cd.accountingRef.toLowerCase().includes(filter.toLowerCase()))
                || (cd.id && cd.id.toLowerCase().includes(filter.toLowerCase()))
            );
        }

        // agregate
        let consultantDocumentsTempAgr: ConsultantDocumentAgregator[] = consultantDocumentsTemp.map(cd => ({ date: (cd.documentDate ? new Date(cd.documentDate) : new Date()), consultantDocument: cd }));
        consultantDocumentsTempAgr = consultantDocumentsTempAgr.concat(consultantPeppolReceivedInvoicesTemp.map(cd => ({ date: (cd.issueDate ? new Date(cd.issueDate) : new Date()), consultantPeppolReceivedInvoice: cd })));
        consultantDocumentsTempAgr = consultantDocumentsTempAgr.concat(consultantPeppolReceivedCreditNotesTemp.map(cd => ({ date: (cd.issueDate ? new Date(cd.issueDate) : new Date()), consultantPeppolReceivedCreditNote: cd })));
        consultantDocumentsTempAgr = consultantDocumentsTempAgr.concat(invoicesTemp.map(cd => ({ date: (cd.invoiceDate ? new Date(cd.invoiceDate) : new Date()), invoice: cd })));
        consultantDocumentsTempAgr = consultantDocumentsTempAgr.sort(SortHelper.ConsultantDocumentAgregatorByDate);

        let LastYear = -1;
        let LastMonth = -1;
        const DocToDo: ConsultantDocumentAgregator[][] = [[]];
        let DocToDoCurrent: ConsultantDocumentAgregator[] = [];
        const DocDone: ConsultantsDocumentsMonth[] = [];
        let DocDoneCurrent: ConsultantsDocumentsMonth | null = null;

        consultantDocumentsTempAgr.forEach((d) => {
            if (d.date.getFullYear() !== LastYear || d.date.getMonth() != LastMonth) {
                LastYear = d.date.getFullYear();
                LastMonth = d.date.getMonth();
                DocToDo.push(DocToDoCurrent);
                DocToDoCurrent = [];
                if (DocDoneCurrent) {
                    DocDone.push(DocDoneCurrent);
                }
                DocDoneCurrent = {
                    year: LastYear, month: LastMonth + 1, docs: []
                };
            }

            if (IsEditable(d)) {
                DocToDoCurrent.push(d);
            }
            else if (DocDoneCurrent !== null) {
                DocDoneCurrent.docs.push(d);
            }
        });
        if (DocDoneCurrent) {
            DocDone.push(DocDoneCurrent);
        }

        SetConsultantDocumentsDoneFilter(DocDone);
        SetConsultantDocumentsFilter(consultantDocumentsTempAgr);
    }, [isLoading, consultantDocuments, consultantPeppolReceivedInvoices, consultantPeppolReceivedCreditNotes, filterConsultant, preFilter, PreFilterConsultantid, ActifFilterDocumentType, filter, consultantid, privateDocumentsOnly, invoices]);

    const MapSkeleton = (i: number) => <TableRow key={i}>
        <TableCell>
            <Skeleton animation="pulse">
                <SkeletonItem className={stylesTab.width15} />
            </Skeleton>
        </TableCell>
        {!privateDocumentsOnly &&
            <TableCell>
                <Skeleton animation="pulse">
                    <SkeletonItem className={stylesTab.width15} />
                </Skeleton>
            </TableCell>
        }
        <TableCell>
            <Skeleton animation="pulse">
                <SkeletonItem className={stylesTab.width15} />
            </Skeleton>
        </TableCell>
        <TableCell>
            <Skeleton animation="pulse">
                <SkeletonItem className={stylesTab.width15} />
            </Skeleton>
        </TableCell>
        <TableCell>
            <Skeleton animation="pulse">
                <SkeletonItem className={stylesTab.width15} />
            </Skeleton>
        </TableCell>
        <TableCell>
            <Skeleton animation="pulse">
                <SkeletonItem className={stylesTab.width15} />
            </Skeleton>
        </TableCell>
    </TableRow>;

    const columnsAccountingDone = privateDocumentsOnly ?
        [
            { columnKey: "Date", label: "Date", className: stylesTab.width17 },
            { columnKey: "Type", label: "Type", className: stylesTab.width17 },
            { columnKey: "Source", label: "Source", className: stylesTab.width17 },
            { columnKey: "Description", label: "Description", className: stylesTab.width17 },
            { columnKey: "Amount", label: t('Amount') + " (" + t('IncludVAT') + ")", className: stylesTab.width17 },
            { columnKey: "Accounting Ref", label: t('AccountingRef'), className: stylesTab.width17 },
        ]
        :
        [
            { columnKey: "Date", label: "Date", className: stylesTab.width17 },
            { columnKey: "Consultant", label: t('Consultant'), className: stylesTab.width17 },
            { columnKey: "Type", label: "Type", className: stylesTab.width17 },
            { columnKey: "Source", label: "Source", className: stylesTab.width17 },
            { columnKey: "Description", label: "Description", className: stylesTab.width17 },
            { columnKey: "Amount", label: t('Amount') + " (" + t('IncludVAT') + ")", className: stylesTab.width17 },
            { columnKey: "Accounting Ref", label: t('AccountingRef'), className: stylesTab.width17 },
        ]
        ;

    const mapConsultantDocument = (cd: ConsultantDocumentAgregator): JSX.Element => {
        const consultantId = GetConsultantId(cd);
        const co = consultants ? consultants.find(e => e.consultantid === consultantId) : undefined;
        const cust = customers && cd.invoice ? customers.find(e => cd.invoice && e.customerid === cd.invoice.customerid) : undefined;
        const coPublisher = consultants && cd.consultantDocument && cd.consultantDocument.consultantidPublisher && cd.consultantDocument.consultantidPublisher !== consultantId ? consultants.find(e => cd.consultantDocument && e.consultantid === cd.consultantDocument.consultantidPublisher) : undefined;
        const keyId =
            (privateDocumentsOnly ? "Priv" : "NPriv")
            +
            (cd.consultantDocument
                ?
                ("doc" + cd.consultantDocument.consultantdocumentid)
                :
                (cd.consultantPeppolReceivedInvoice
                    ?
                    ("peppolRecInv" + cd.consultantPeppolReceivedInvoice.peppolReceivedInvoiceId)
                    :
                    (cd.consultantPeppolReceivedCreditNote
                        ?
                        ("peppolRecCn" + cd.consultantPeppolReceivedCreditNote.peppolReceivedCreditNoteId)
                        :
                        (cd.invoice
                            ?
                            ("invoice" + cd.invoice.invoiceid)
                            :
                            "unknown"
                        )
                    )
                ));
        const lock = GetLock(cd);
        const accountingRef = GetAccountingRef(cd);
        const docType = GetDocumentTypeId(cd);
        const amount = GetAmount(cd, data, co, cust);
        const peppolStatus = PeppolStatus(cd);
        let DocType_ID = getDocumentTypeString(docType);
        if (cd.consultantPeppolReceivedInvoice) {
            DocType_ID = DocType_ID + " :  " + cd.consultantPeppolReceivedInvoice.id;
        }
        if (cd.consultantPeppolReceivedCreditNote) {
            DocType_ID = DocType_ID + " : " + cd.consultantPeppolReceivedCreditNote.id;
        }
        return <TableRow key={keyId}>
            <TableCell>
                <Button appearance="transparent" className={stylesTab.TestButton}
                    onClick={() => {
                        console.log("click");
                        if (cd.invoice) {
                            dispatch(dataActionCreators.requestInvoiceQuickView(cd.invoice));
                        }
                    }}
                >
                    {cd.date ? cd.date.toLocaleDateString() : "-"}
                </Button>
            </TableCell>
            {!privateDocumentsOnly &&
                <TableCell>
                    {co && co.displayName
                        ? <Button appearance="transparent" className={stylesTab.TestButton}
                            onClick={() => dispatch(ConsultantActionCreators.requestConslutantQuickView(co ? co : null))}>
                            {co.displayName ? co.displayName : "?"}
                        </Button>
                        : "?"
                    }
                    {coPublisher &&
                        <>
                            <Button appearance="transparent" size="small" className={mergeClasses(stylesTab.TestButton, stylesTab.LeftMargin)}
                                onClick={() => dispatch(ConsultantActionCreators.requestConslutantQuickView(coPublisher ? coPublisher : null))}>
                                {"(Create by " + (coPublisher.displayName ? coPublisher.displayName : "?") + ")"}
                            </Button>
                        </>
                    }
                </TableCell>
            }
            <TableCell>
                {DocType_ID}
                {IsPeppol(cd) &&
                    <Badge appearance="filled" color="brand" style={{ marginLeft: "4px" }}>
                        Peppol
                    </Badge>
                }
                {IsPeppolTest(cd) &&
                    <Badge appearance="filled" color="danger" style={{ marginLeft: "4px" }}>
                        {t('TESTENV')}
                    </Badge>
                }
                {(peppolStatus === null || peppolStatus === 0) &&
                    <Badge appearance="filled" color="warning" style={{ marginLeft: "4px" }}>
                        {t('OnHold')}
                    </Badge>
                }
                {peppolStatus === 1 &&
                    <Badge appearance="filled" color="warning" style={{ marginLeft: "4px" }}>
                        {t('Accepted')}
                    </Badge>
                }
                {peppolStatus === 2 &&
                    <Badge appearance="filled" color="success" style={{ marginLeft: "4px" }}>
                        {t('Payed')}
                    </Badge>
                }
                {peppolStatus === 3 &&
                    <Badge appearance="filled" color="danger" style={{ marginLeft: "4px" }}>
                        {t('Refused')}
                    </Badge>
                }
                {cd.invoice && !cd.invoice.emailSent && !cd.invoice.peppolSent &&
                    <Badge appearance="filled" color="warning" style={{ marginLeft: "4px" }}>
                        {t('NotEmailed')}
                    </Badge>
                }
                {privateDocumentsOnly && coPublisher &&
                    <>
                        <Button appearance="transparent" size="small" className={mergeClasses(stylesTab.TestButton, stylesTab.LeftMargin)}
                            onClick={() => dispatch(ConsultantActionCreators.requestConslutantQuickView(coPublisher ? coPublisher : null))}>
                            {"(Create by " + (coPublisher.displayName ? coPublisher.displayName : "?") + ")"}
                        </Button>
                    </>
                }
            </TableCell>
            <TableCell>
                {GetSource(cd, customers)}
            </TableCell>
            <TableCell>
                {GetDescription(cd)}
            </TableCell>
            <TableCell>
                <TableCellLayout>
                    {amount ? amount.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) : "-"}
                </TableCellLayout>
                <TableCellActions>
                    {((!lock && accountingRef === null) || (isAdmin || canManageConsultantDocuments)) &&
                        docType !== 2 && cd.consultantDocument &&
                        <Button
                            icon={<EditIcon />}
                            appearance="subtle"
                            aria-label={t('Edit')}
                            onClick={() => {
                                if (cd.consultantDocument) dispatch(ConsultantActionCreators.requestConsultantDocumentEdition(cd.consultantDocument));
                            }}
                        />
                    }
                    {((!lock && accountingRef === null) || (isAdmin || canManageConsultantDocuments)) &&
                        (docType === 2 && cd.consultantDocument && cd.consultantDocument.consultantInvoiceid !== null && cd.consultantDocument.consultantInvoiceid !== undefined) &&
                        <Button
                            icon={<EditIcon />}
                            appearance="subtle"
                            aria-label={t('Edit')}
                            onClick={() => {
                                const ci = consultantsInvoices?.find(ci => cd.consultantDocument && ci.consultantInvoiceid === cd.consultantDocument.consultantInvoiceid);
                                if (ci) {
                                    dispatch(ConsultantActionCreators.requestConsultantInvoiceEdition(ci));
                                }
                            }
                            }
                        />
                    }
                    {((!lock && accountingRef === null) || (isAdmin || canManageConsultantDocuments)) &&
                        cd.consultantPeppolReceivedInvoice &&
                        <Button
                            icon={<EditIcon />}
                            appearance="subtle"
                            aria-label={t('Edit')}
                            onClick={() => {
                                if (cd.consultantPeppolReceivedInvoice) dispatch(dataActionCreators.editReceivedPeppolDoc(cd.consultantPeppolReceivedInvoice));
                            }
                            } />
                    }
                    {((!lock && accountingRef === null) || (isAdmin || canManageConsultantDocuments)) &&
                        cd.consultantPeppolReceivedCreditNote &&
                        <Button
                            icon={<EditIcon />}
                            appearance="subtle"
                            aria-label={t('Edit')}
                            onClick={() => {
                                if (cd.consultantPeppolReceivedCreditNote) dispatch(dataActionCreators.editReceivedPeppolDoc(cd.consultantPeppolReceivedCreditNote));
                            }
                            } />
                    }
                    {cd.consultantDocument && cd.consultantDocument.documentSharePointFileUniqueId !== "00000000-0000-0000-0000-000000000000" &&
                        <Button
                            icon={<SharePointSVG />}
                            appearance="subtle"
                            aria-label={t('ViewInSharePoint')}
                            onClick={() => {
                                TokenHelper.GetToken(instance, teamsState)
                                    .then(token => {
                                        if (token !== null && cd.consultantDocument) {
                                            DownloadSPOLinkAndNav('api/ConsultantsDocuments/' + cd.consultantDocument.consultantdocumentid + "/SharePointLink", token);
                                        }
                                    });
                            }}
                        />
                    }
                    {!lock && accountingRef === null && cd.consultantDocument && docType !== 2 &&
                        <Button
                            icon={<TrashCanIcon />}
                            appearance="subtle"
                            aria-label="Delete"
                            onClick={() => {
                                if (cd.consultantDocument) dispatch(ConsultantActionCreators.requestConsultantDocumentdeletion(cd.consultantDocument));
                            }
                            } />
                    }
                    {cd.consultantPeppolReceivedInvoice && viewDebugInfo &&
                        <Button
                            icon={<TrashCanIcon />}
                            appearance="subtle"
                            aria-label="Delete"
                            onClick={() => {
                                if (cd.consultantPeppolReceivedInvoice) dispatch(ConsultantActionCreators.requestConsultantPeppolReceivedInvoicedeletion(cd.consultantPeppolReceivedInvoice));
                            }
                            } />
                    }
                    {cd.invoice &&
                        <>
                            {((!lock && cd.invoice.paymentDate === null && cd.invoice.payment === 0 && !cd.invoice.emailSent && !cd.invoice.peppolSent) || isAdmin) &&
                                <Button
                                    icon={<EditIcon />}
                                    appearance="subtle"
                                    className={stylesTab.TestButton}
                                    title={t('Edit')}
                                    onClick={() => {
                                        if (cd.invoice) dispatch(dataActionCreators.requestInvoiceEdition(cd.invoice));
                                    }} />
                            }
                            <Button
                                icon={<GlobeDesktopIcon />}
                                appearance="subtle"
                                className={stylesTab.TestButton}
                                title={t("DownloadPeppolInvoice")}
                                onClick={() => {
                                    TokenHelper.GetToken(instance, teamsState)
                                        .then(token => {
                                            if (token !== null && cd.invoice && cd.invoice.invoiceid) {
                                                DownloadFileAndSave('api/Invoices/' + cd.invoice.invoiceid + "/GenUBLInvoice", token);
                                            }
                                        });
                                }} />
                            {cd.invoice.peppolSent &&
                                <Button
                                    icon={<GlobeClockIcon />}
                                    appearance="subtle"
                                    className={stylesTab.TestButton}
                                    title={t("ViewPeppolInvoiceSendInfo")}
                                    onClick={() => {
                                        alert("Not implemented yet");
                                    }} />

                            }
                            {((!lock && !cd.invoice.emailSent && !cd.invoice.peppolSent) || viewDebugInfo) &&
                                <>
                                    <Button
                                        icon={<GlobeArrowForwardIcon />}
                                        appearance="subtle"
                                        className={stylesTab.TestButton}
                                        title={t('PeppolInvoice')}
                                        onClick={() => {
                                            if (cd.invoice) dispatch(dataActionCreators.requestInvoiceSendUBL(cd.invoice));
                                        }} />
                                    <Button
                                        icon={<DeleteIcon />}
                                        appearance="subtle"
                                        className={stylesTab.TestButton}
                                        title={t("DeletePeppolInvoice")}
                                        onClick={() => {
                                            if (cd.invoice) dispatch(dataActionCreators.requestInvoiceDeletion(cd.invoice));
                                        }} />
                                </>
                            }
                        </>
                    }
                </TableCellActions>
            </TableCell>
            {/*{(accountingRef !== null || lock === true) &&*/}
            <TableCell>
                {accountingRef}
            </TableCell>
            {/*    }*/}
        </TableRow>;
    };

    return <div className={stylesTab.rootSub}>
        <div className={stylesTab.MainBar}>
            {(!privateDocumentsOnly || preFilter == undefined) &&
                <Popover positioning="below-start">
                    <PopoverTrigger>
                        <Button icon={<FilterIcon />} shape="circular" title="Filter" />
                    </PopoverTrigger>
                    <PopoverSurface>
                        <div className={stylesTab.List}>
                            {!privateDocumentsOnly && !PreFilterConsultantid &&
                                <Field label={t('Consultant')}>
                                    <ConsultantDropdown
                                        currentConsultant={filterConsultant}
                                        setConsultant={setFilterConsultant}
                                    />
                                </Field>
                            }
                            {
                                preFilter == undefined &&
                                <Field label="Type">
                                    <BasicDocumentTypeDropdown
                                        currentDocumentType={filterDocumentType}
                                        setDocumentType={setFilterDocumentType}
                                    />
                                </Field>
                            }
                        </div>
                    </PopoverSurface>
                </Popover>
            }
            {filterConsultant &&
                <Tag
                    dismissible
                    dismissIcon={{ "aria-label": "remove" }}
                    size="small"
                    onClick={() => { setFilterConsultant(undefined); }}
                    appearance="outline"
                >
                    {t('Consultant') + " = " + filterConsultant.displayName}
                </Tag>}
            {filterDocumentType &&
                <Tag
                    dismissible
                    dismissIcon={{ "aria-label": "remove" }}
                    size="small"
                    onClick={() => { setFilterDocumentType(null); }}
                    appearance="outline"
                >
                    {"Type = " + getDocumentTypeString(filterDocumentType)}
                </Tag>}
            <SearchBox
                placeholder={t('Contains')}
                onChange={(e: SearchBoxChangeEvent, data: InputOnChangeData) => { setFilter(data.value); }}
                dismiss={{ onClick: () => { setFilter(null); } }}
                className={styles.fluid}
            />
            <div className={stylesTab.MarginLeftAuto}>
                <Button icon={<AddIcon />} shape="circular" title={t('Add')}
                    onClick={() => {
                        const pa: ConsultantDocument = {
                            consultantdocumentid: "",
                            consultantidPublisher: "",
                            consultantid: privateDocumentsOnly && consultantid ? consultantid : null,
                            createDate: null,
                            lastUpdateDate: null,
                            documentSharePointFileUniqueId: "",
                            documentSharePointFileOriginalName: "",
                            documentTypeId: 1,
                            documentDate: null,
                            documentSource: null,
                            documentAmount: 0,
                            lock: false,
                            accountingRef: null,
                            description: null,
                        };
                        dispatch(ConsultantActionCreators.requestConsultantDocumentCreation(pa));
                    }} />
            </div>

        </div>
        <h2>{t('Ongoing')}</h2>
        <Table arial-label="Default table">
            <TableHeader>
                {/*    <TableRow>*/}
                {/*        {columns.map((column) => (*/}
                {/*            <TableHeaderCell key={column.columnKey} className={column.className}>*/}
                {/*                {column.label}*/}
                {/*            </TableHeaderCell>*/}
                {/*        ))}*/}
                {/*    </TableRow>*/}
                <TableRow>
                    {columnsAccountingDone.map((column) => (
                        <TableHeaderCell key={column.columnKey} className={column.className}>
                            {column.label}
                        </TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {(consultantDocumentsFilter === undefined || isLoading)
                    ? [...Array(30)].map((_, index) => MapSkeleton(index))
                    : consultantDocumentsFilter.filter(t => IsEditable(t))
                        .map(p => mapConsultantDocument(p)
                        )}
            </TableBody>
        </Table>
        <h2>{t('Accounted')}</h2>
        <Accordion multiple collapsible>
            {consultantDocumentsDoneFilter.filter((cds) => cds.docs.length > 0).map((cds) => {
                return <AccordionItem key={"Accounted" + cds.year + cds.month} value={" Done" + (cds.month) + "/" + cds.year} >
                    <AccordionHeader><Divider appearance="brand">{(cds.month) + "/" + cds.year}</Divider></AccordionHeader>
                    <AccordionPanel>
                        <Table arial-label="Default table">
                            <TableHeader>
                                <TableRow>
                                    {columnsAccountingDone.map((column) => (
                                        <TableHeaderCell key={column.columnKey} className={column.className}>
                                            {column.label}
                                        </TableHeaderCell>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {cds.docs.map(p => mapConsultantDocument(p))}
                            </TableBody>
                        </Table>
                    </AccordionPanel>
                </AccordionItem>;
            })}
        </Accordion>
    </div>;
};